// extracted by mini-css-extract-plugin
module.exports = {"tablist":"tabs_tablist__3FKmM","tab":"tabs_tab__8NOVL","tabs_right":"tabs_tabs_right__2YeOg","hidden":"tabs_hidden__36d3D","selected":"tabs_selected__1BKMi"};